import { styled } from '@linaria/react';
import { bodyFont, colors, fonts, primitives, semantic, size, space } from '../../theme/tokens';

export const CardBase = styled.div<{ $unavailable?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
  padding: ${space['space-400']};
  background: ${semantic.bg.canvas};
  border: 1px solid ${semantic.border.subtle};
  border-radius: ${size.radius['radius-md']};
  opacity: ${({ $unavailable }) => ($unavailable ? 0.55 : 1)};
`;

export const TopRow = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: start;
  gap: ${space['space-300']};
`;

export const TimePill = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${space['space-100']} ${space['space-300']};
  border-radius: 9999px;
  background: ${semantic.bg.surfaceSubtle};
  font-family: ${bodyFont};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  white-space: nowrap;
`;

export const MiddleColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-100']};
  min-width: 0;
`;

export const Title = styled.h3`
  font-family: ${bodyFont};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  margin: 0;
  line-height: ${primitives.typography.lineHeight.normal};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Meta = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
`;

export const Price = styled.div`
  font-family: ${bodyFont};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  white-space: nowrap;
`;

export const BottomRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space['space-300']};
`;

export const SpotsLeft = styled.span<{ $low: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: ${space['space-200']};
  font-family: ${bodyFont};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};

  &::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ $low }) => ($low ? semantic.bg.urgencyStrong : semantic.bg.positiveStrong)};
  }
`;

export const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 64px;
  height: 40px;
  padding: 0 ${space['space-400']};
  border: none;
  border-radius: 9999px;
  background: ${colors.primary};
  color: ${semantic.text.inverse};
  cursor: pointer;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.9;
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
`;
